(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ts-sticky-product-bar')) {
    customElements.define(
      'ts-sticky-product-bar',
      class TsStickyProductBar extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.getElementById(this.dataset.mainButtonId);
          this.mainPrice = document.getElementById(this.dataset.mainPriceId);
          this.stickyButton = this.querySelector('[data-ts-sticky-submit]');
          this.stickyLabel = this.querySelector('[data-ts-sticky-label]');
          this.stickyPrice = this.querySelector('[data-ts-sticky-price]');

          if (!this.mainButton || !this.stickyButton) {
            this.remove();
            return;
          }

          this.onStickyClick = () => {
            if (this.stickyButton.disabled) return;
            this.mainButton.click();
          };

          this.scheduleVisibilityUpdate = () => {
            if (this.visibilityFrame) return;
            this.visibilityFrame = requestAnimationFrame(() => {
              this.visibilityFrame = null;
              this.updateVisibility();
            });
          };

          this.stickyButton.addEventListener('click', this.onStickyClick);
          window.addEventListener('scroll', this.scheduleVisibilityUpdate, { passive: true });
          window.addEventListener('resize', this.scheduleVisibilityUpdate, { passive: true });

          this.buttonObserver = new MutationObserver(() => this.syncButton());
          this.buttonObserver.observe(this.mainButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
          });

          if (this.mainPrice) {
            this.priceObserver = new MutationObserver(() => this.syncPrice());
            this.priceObserver.observe(this.mainPrice, {
              attributes: true,
              childList: true,
              subtree: true,
            });
          }

          this.syncButton();
          this.syncPrice();
          this.updateVisibility();
        }

        disconnectedCallback() {
          this.stickyButton?.removeEventListener('click', this.onStickyClick);
          window.removeEventListener('scroll', this.scheduleVisibilityUpdate);
          window.removeEventListener('resize', this.scheduleVisibilityUpdate);
          this.buttonObserver?.disconnect();
          this.priceObserver?.disconnect();
          if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
        }

        syncButton() {
          const mainLabel = this.mainButton.querySelector('span');
          const labelText = mainLabel?.textContent?.trim();
          const isLoading = this.mainButton.classList.contains('loading');
          const isDisabled =
            this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true' || isLoading;

          if (labelText) this.stickyLabel.textContent = labelText;
          this.stickyButton.disabled = isDisabled;
          this.stickyButton.setAttribute('aria-busy', String(isLoading));
          this.classList.toggle('is-loading', isLoading);
        }

        syncPrice() {
          if (!this.mainPrice || !this.stickyPrice) return;

          const salePrice = this.mainPrice.querySelector('.price--on-sale .price-item--sale, .price--on-sale .price-item--last');
          const regularPrice = this.mainPrice.querySelector('.price__regular .price-item--regular, .price-item--regular');
          const activePrice = salePrice || regularPrice;
          const priceText = activePrice?.textContent?.trim();

          if (priceText) this.stickyPrice.textContent = priceText;
          this.stickyPrice.classList.toggle('is-sale', Boolean(salePrice));
        }

        updateVisibility() {
          const buttonRect = this.mainButton.getBoundingClientRect();
          const hasPassedMainButton = buttonRect.bottom < -96;
          const hasBlockingDialog = Boolean(
            document.querySelector('.product-media-modal[open], quick-add-modal[open], cart-drawer.active')
          );
          const shouldShow = hasPassedMainButton && !hasBlockingDialog;

          this.classList.toggle('is-visible', shouldShow);
          this.setAttribute('aria-hidden', String(!shouldShow));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
